<div class="row">
  <div class="col-md-12">
    <div class="card">
      <div class="card-header">
        <h3 class="form-section"><i class="ft-user-plus"></i> Update User <button (click)="CancelEditUser()"
            class="btn btn-danger float-right ">Discard</button> </h3>
        <hr>
      </div>
      <div class="card-body">
        <div class="px-3">

          <form #loginForm="ngForm" class="form" (ngSubmit)="AddUser()" >
            <div class="row justify-content-md-center">
              <div class="col-md-12">
                <div class="form-body">
                  <div class="row">
                    <div class="form-group col-12 mb-2">
                      <h5 for="eventRegInput2">User ID</h5>
                      <input disabled [(ngModel)]="model.userID" name="UserID" type="number" id="eventRegInput2" class="form-control" placeholder="ID" >
                    </div>
                  </div>

                  <div class="row">
                    <div class="form-group col-12 mb-2">
                      <h5 for="eventRegInput2">Name</h5>

                   <input type="text" [(ngModel)]="model.username" name="UserName" id="eventRegInput2"  class="form-control" placeholder="Name">
                    </div>
                  </div>



                  <div class="row">
                    <div class="form-group col-12 mb-2">
                      <h5 for="eventRegInput3">User Priviledge</h5>
                      <select  [(ngModel)]="model.user_Privilege" required name="Priviledge" class="browser-default custom-select">
                        <option value="USER">USER</option>
                        <option value="MANAGER" >MANAGER</option>
                        <option value="OPERATOR" >OPERATOR</option>
                        <option value="REGISTOR">REGISTOR</option>



                      </select>
                     </div>
                  </div>


                  <div class="row">
                    <div class="form-group col-12 mb-2">

                      <div class="input-group">
                        <div class="custom-control custom-radio d-inline-block ml-1">
                          <input (change)="selectChangeHandler($event)" [ngModel]="model.mode" name="Mode" value="FP"  type="radio" id="customRadioInline1"  class="custom-control-input">
                          <label class="custom-control-label"  for="customRadioInline1">FingerPrint</label>
                        </div>
                        <div class="custom-control custom-radio d-inline-block ml-2">
                          <input (change)="selectChangeHandler($event)" [ngModel]="model.mode" value="Face" name="Mode" type="radio" id="customRadioInline2" checked="" class="custom-control-input">
                          <label class="custom-control-label" for="customRadioInline2">Face</label>
                        </div>
                        <div class="custom-control custom-radio d-inline-block ml-2">
                          <input (change)="selectChangeHandler($event)" [ngModel]="model.mode" value="None" name="Mode" type="radio" id="customRadioInline3" checked="" class="custom-control-input">
                          <label class="custom-control-label" for="customRadioInline3">None</label>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>

            <div class="form-actions clearfix">
              <div class="buttons-group float-right">

                <button type="submit" class="btn btn-raised btn-primary mr-1">
                  <i class="fa fa-check-square-o"></i> Save
                </button>
              </div>


            </div>
          </form>

        </div>
      </div>
    </div>
  </div>
</div>
<!-- <ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
  <h3 style="color: white">Please Wait ... </h3>
  </ngx-spinner> -->
